
export default class Controller {
    constructor(options) {
        this.metadata = options.metadata;
        // this.page  = options.page || 1;
    }
}
